/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
/**
 * @deprecated This icon map exists only to support the legacy UseSvg.vue component.
 * For new code, import SVG icons directly:
 *   import MyIcon from "assets/icons/my-icon.svg?vue";
 *
 * Instead of loading icons from sprite files via <use xlink:href>,
 * we import each icon as a Vue component and look it up by name at runtime.
 *
 * To add a new icon: import it and add an entry to the appropriate map.
 */

// Jiffy icons (type="jiffy", the default)
import affirm from "assets/icons/affirm.svg";
import affirmBtn from "assets/icons/affirm-btn.svg";
import afterpayBtn from "assets/icons/afterpay-btn.svg";
import cashappBtn from "assets/icons/cashapp-btn.svg";
import klarnaBtn from "assets/icons/klarna-btn.svg";
import sezzleBtn from "assets/icons/sezzle-btn.svg";
import venmoBtn from "assets/icons/venmo-btn.svg";
import afterpay from "assets/icons/afterpay.svg";
import afterpayLogo from "assets/icons/afterpay-logo.svg";
import alertCircle from "assets/icons/alert-circle.svg";
import applePayLogo from "assets/icons/apple-pay-logo.svg";
import arrowLeft from "assets/icons/arrow-left.svg";
import arrowLeftTiny from "assets/icons/arrow-left-tiny.svg";
import arrowRight from "assets/icons/arrow-right.svg";
import arrowRightLong from "assets/icons/arrow-right-long.svg";
import arrowRightTiny from "assets/icons/arrow-right-tiny.svg";
import back from "assets/icons/back.svg";
import borneo from "assets/icons/borneo.svg";
import bulb from "assets/icons/bulb.svg";
import calendar from "assets/icons/calendar.svg";
import canva from "assets/icons/canva.svg";
import cartNoWheels from "assets/icons/cart-no-wheels.svg";
import cashapp from "assets/icons/cashapp.svg";
import check from "assets/icons/check.svg";
import checkBold from "assets/icons/check-bold.svg";
import checkCircle from "assets/icons/check-circle.svg";
import checkCircleBold from "assets/icons/check-circle-bold.svg";
import checkCirclePrimary from "assets/icons/check-circle-primary.svg";
import checkCurvy from "assets/icons/check-curvy.svg";
import checkVerified from "assets/icons/check-verified.svg";
import checkbox from "assets/icons/checkbox.svg";
import checkmarkCircled from "assets/icons/checkmark-circled.svg";
import chevronDown from "assets/icons/chevron-down.svg";
import cloudUpload from "assets/icons/cloud-upload.svg";
import cloudUpload2 from "assets/icons/cloud-upload-2.svg";
import cross from "assets/icons/cross.svg";
import crossThin from "assets/icons/cross-thin.svg";
import customColor from "assets/icons/custom-color.svg";
import downloadLine from "assets/icons/download-line.svg";
import edit from "assets/icons/edit.svg";
import ellipse from "assets/icons/ellipse.svg";
import etsyLogo from "assets/icons/etsy-logo.svg";
import fourOclock from "assets/icons/four-oclock.svg";
import freeShippingTruck from "assets/icons/free-shipping-truck.svg";
import fullScreen from "assets/icons/full-screen.svg";
import greenBox from "assets/icons/green-box.svg";
import grid from "assets/icons/grid.svg";
import guarantee3 from "assets/icons/guarantee-3.svg";
import home from "assets/icons/home.svg";
import idea from "assets/icons/idea.svg";
import infoCircle from "assets/icons/info-circle.svg";
import infoCircleBold from "assets/icons/info-circle-bold.svg";
import infoCircleThin from "assets/icons/info-circle-thin.svg";
import jLogo from "assets/icons/j-logo.svg";
import jiffy1St from "assets/icons/jiffy-1-st.svg";
// jiffy-logo-small: pre-existing broken reference, icon never existed in jiffy sprite
import jiffyShirtsInline from "assets/icons/jiffy-shirts-inline.svg";
import jiffyStickersInline from "assets/icons/jiffy-stickers-inline.svg";
import jiffyTransfersInline from "assets/icons/jiffy-transfers-inline.svg";
import johnSmithIcon from "assets/icons/john-smith-icon.svg";
import lightbulbInfo from "assets/icons/lightbulb-info.svg";
import menuClose from "assets/icons/menu-close.svg";
import minus from "assets/icons/minus.svg";
import modalClose from "assets/icons/modal-close.svg";
import modalCloseBig from "assets/icons/modal-close-big.svg";
import pencilPlain from "assets/icons/pencil-plain.svg";
import pencilWithDoc from "assets/icons/pencil-with-doc.svg";
import plus from "assets/icons/plus.svg";
import popUp from "assets/icons/pop-up.svg";
import promotions from "assets/icons/promotions.svg";
import questionCircle from "assets/icons/question-circle.svg";
import refresh from "assets/icons/refresh.svg";
import rotate from "assets/icons/rotate.svg";
import rotateIcon from "assets/icons/rotate-icon.svg";
import search from "assets/icons/search.svg";
import sendIcon from "assets/icons/send-icon.svg";
import shirtO from "assets/icons/shirt-o.svg";
import spaceship from "assets/icons/spaceship.svg";
import spangleWand from "assets/icons/spangle-wand.svg";
import sparklesGradient from "assets/icons/sparkles-gradient.svg";
import starsCorners from "assets/icons/stars-corners.svg";
import strongInfo from "assets/icons/strong-info.svg";
import thumbsUp from "assets/icons/thumbs-up.svg";
import thumbsUpGreen from "assets/icons/thumbs-up-green.svg";
import trash from "assets/icons/trash.svg";
import trashPrint from "assets/icons/trash-print.svg";
import uploadCloudBorder from "assets/icons/upload-cloud-border.svg";
import uploadCloudBox from "assets/icons/upload-cloud-box.svg";
import uploadCloudPrint from "assets/icons/upload-cloud-print.svg";
import venmo from "assets/icons/venmo.svg";
import warning from "assets/icons/warning.svg";
import warningHexagon from "assets/icons/warning-hexagon.svg";
import zapFast from "assets/icons/zap-fast.svg";
import zoomInO from "assets/icons/zoom-in-o.svg";
import zoomInPrint from "assets/icons/zoom-in-print.svg";
import zoomOutO from "assets/icons/zoom-out-o.svg";
import award from "assets/icons/award.svg";
import basket from "assets/icons/basket.svg";
import boxJiffyCheck from "assets/icons/box-jiffy-check.svg";
import boxJiffyPacked from "assets/icons/box-jiffy-packed.svg";
import crossCircle from "assets/icons/cross-circle.svg";
import dollarShield from "assets/icons/dollar-shield.svg";
import dollarSign from "assets/icons/dollar-sign.svg";
import fastDelivery from "assets/icons/fast-delivery.svg";
import guarantee from "assets/icons/guarantee.svg";
import heart from "assets/icons/heart.svg";
import heartFilled from "assets/icons/heart-filled.svg";
import hellip from "assets/icons/hellip.svg";
import imageCheck from "assets/icons/image-check.svg";
import jiffyStickersLogo from "assets/icons/jiffy-stickers-logo.svg";
import lightning1 from "assets/icons/lightning-1.svg";
import loader from "assets/icons/loader.svg";
import lock from "assets/icons/lock.svg";
import lockOutline from "assets/icons/lock-outline.svg";
import markerPin from "assets/icons/marker-pin.svg";
import pencil from "assets/icons/pencil.svg";
import plusCircle from "assets/icons/plus-circle.svg";
import proColorWheel from "assets/icons/pro-color-wheel.svg";
import sezzleLogo from "assets/icons/sezzle-logo.svg";
import shipping from "assets/icons/shipping.svg";
import stickyNote from "assets/icons/sticky-note.svg";
import thumbsDown from "assets/icons/thumbs-down.svg";

// Neck labels icons (type="neck_labels") — stored with care- prefix
import careChlorineBleach from "assets/icons/neck-label-chlorine-bleach.svg";
import careDoNotBleach from "assets/icons/neck-label-do-not-bleach.svg";
import careDoNotIron from "assets/icons/neck-label-do-not-iron.svg";
import careDoNotWash from "assets/icons/neck-label-do-not-wash.svg";

const jiffyIcons = {
  affirm: affirm,
  "affirm-btn": affirmBtn,
  "afterpay-btn": afterpayBtn,
  "cashapp-btn": cashappBtn,
  "klarna-btn": klarnaBtn,
  "sezzle-btn": sezzleBtn,
  "venmo-btn": venmoBtn,
  afterpay: afterpay,
  "afterpay-logo": afterpayLogo,
  "alert-circle": alertCircle,
  "apple-pay-logo": applePayLogo,
  "arrow-left": arrowLeft,
  "arrow-left-tiny": arrowLeftTiny,
  "arrow-right": arrowRight,
  "arrow-right-long": arrowRightLong,
  "arrow-right-tiny": arrowRightTiny,
  back: back,
  borneo: borneo,
  bulb: bulb,
  calendar: calendar,
  canva: canva,
  "cart-no-wheels": cartNoWheels,
  cashapp: cashapp,
  check: check,
  "check-bold": checkBold,
  "check-circle": checkCircle,
  "check-circle-bold": checkCircleBold,
  "check-circle-primary": checkCirclePrimary,
  "check-curvy": checkCurvy,
  "check-verified": checkVerified,
  checkbox: checkbox,
  "checkmark-circled": checkmarkCircled,
  "chevron-down": chevronDown,
  "cloud-upload": cloudUpload,
  "cloud-upload-2": cloudUpload2,
  cross: cross,
  "cross-thin": crossThin,
  "custom-color": customColor,
  "download-line": downloadLine,
  edit: edit,
  ellipse: ellipse,
  "etsy-logo": etsyLogo,
  "four-oclock": fourOclock,
  "free-shipping-truck": freeShippingTruck,
  "full-screen": fullScreen,
  "green-box": greenBox,
  grid: grid,
  "guarantee-3": guarantee3,
  home: home,
  idea: idea,
  "info-circle": infoCircle,
  "info-circle-bold": infoCircleBold,
  "info-circle-thin": infoCircleThin,
  "j-logo": jLogo,
  "jiffy-1-st": jiffy1St,
  "jiffy-shirts-inline": jiffyShirtsInline,
  "jiffy-stickers-inline": jiffyStickersInline,
  "jiffy-transfers-inline": jiffyTransfersInline,
  "john-smith-icon": johnSmithIcon,
  "lightbulb-info": lightbulbInfo,
  "menu-close": menuClose,
  minus: minus,
  "modal-close": modalClose,
  "modal-close-big": modalCloseBig,
  "pencil-plain": pencilPlain,
  "pencil-with-doc": pencilWithDoc,
  plus: plus,
  "pop-up": popUp,
  promotions: promotions,
  "question-circle": questionCircle,
  refresh: refresh,
  rotate: rotate,
  "rotate-icon": rotateIcon,
  search: search,
  "send-icon": sendIcon,
  "shirt-o": shirtO,
  spaceship: spaceship,
  "spangle-wand": spangleWand,
  "sparkles-gradient": sparklesGradient,
  "stars-corners": starsCorners,
  "strong-info": strongInfo,
  "thumbs-up": thumbsUp,
  "thumbs-up-green": thumbsUpGreen,
  trash: trash,
  "trash-print": trashPrint,
  "upload-cloud-border": uploadCloudBorder,
  "upload-cloud-box": uploadCloudBox,
  "upload-cloud-print": uploadCloudPrint,
  venmo: venmo,
  warning: warning,
  "warning-hexagon": warningHexagon,
  "zap-fast": zapFast,
  "zoom-in-o": zoomInO,
  "zoom-in-print": zoomInPrint,
  "zoom-out-o": zoomOutO,
  award: award,
  basket: basket,
  "box-jiffy-check": boxJiffyCheck,
  "box-jiffy-packed": boxJiffyPacked,
  "cross-circle": crossCircle,
  "dollar-shield": dollarShield,
  "dollar-sign": dollarSign,
  "fast-delivery": fastDelivery,
  guarantee: guarantee,
  heart: heart,
  "heart-filled": heartFilled,
  hellip: hellip,
  "image-check": imageCheck,
  "jiffy-stickers-logo": jiffyStickersLogo,
  "lightning-1": lightning1,
  loader: loader,
  lock: lock,
  "lock-outline": lockOutline,
  "marker-pin": markerPin,
  pencil: pencil,
  "plus-circle": plusCircle,
  "pro-color-wheel": proColorWheel,
  "sezzle-logo": sezzleLogo,
  shipping: shipping,
  "sticky-note": stickyNote,
  "thumbs-down": thumbsDown
};

const neckLabelsIcons = {
  "chlorine-bleach": careChlorineBleach,
  "do-not-bleach": careDoNotBleach,
  "do-not-iron": careDoNotIron,
  "do-not-wash": careDoNotWash
};

// product_collections and brand_page types use the same icons as jiffy
const iconMaps = {
  jiffy: jiffyIcons,
  brand_page: jiffyIcons,
  product_collections: jiffyIcons,
  neck_labels: neckLabelsIcons
};

export function getIconComponent(name: any, type = "jiffy") {
  // @ts-ignore TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const map = iconMaps[type] || jiffyIcons;
  return map[name] || null;
}
